<template lang="pug">
	.editEmployeeFaceContainer
		form(@submit.prevent="faceFormSubmitted")
			.modal-card: .modal-card-body
				.columns
					.column
						//- b-upload Buefy component
						b-field(label="Upload Image")
							b-upload(v-model="fileUpload", @input="handleFileUpload", drag-drop, accept="image/*", :disabled="isLoading")
								section.section
									.content.has-text-centered
										p: b-icon(icon="upload", size="is-large", pack="fas")
										p Drop your files here or click to upload
					.column
						//- Preview of image and image filename
						figure.image.is-square(style="max-height: 10rem;")
							img.centerImage(:src="fileUploadPreviewSrc")
						br
						b-tag(v-show="fileUpload") {{ fileUpload ? fileUpload.name : "" }}

				//- Form Buttons
				.level
					.level-left
						.level-item: input.button.is-primary(type="submit", name="submit", value="Upload", :disabled="isLoading")
						.level-item: button.button.is-light(@click.prevent="clearForm", :disabled="isLoading") Clear
					.level-right
						.level-item: button.button.is-dark(@click.prevent="$parent.close()") Close
		
</template>

<style lang="scss" scoped>
	.modal-card-body {
		border-radius: 6px;
	}

	// Make the preview image nice
	img.centerImage {
		max-width: 100%;
		max-height: 100%;
		width: auto !important;
		height: auto !important;
		margin: auto;
	}
</style>

<script>
	import {} from "vuex";
	import apiService from "@/services/apiService.js";

	export default {
		props: ["currentEmployee"], // details of current employee
		data() {
			return {
				isLoading: false,
				fileUpload: null,
				fileUploadPreviewSrc: "",
				errors: [],
				serverErrors: []
			};
		},
		methods: {
			// Handle file upload
			handleFileUpload() {
				if (this.fileUpload.size > 5 * 1024 * 1024) {
					// File size too big
					this.fileUpload = null;
					this.$buefy.snackbar.open({
						duration: 3000,
						message: "Image file size cannot exceed 3 MB.",
						type: "is-danger",
						position: "is-top-right"
					});
				} else {
					// Show preview
					let reader = new FileReader();
					reader.onload = (e) => {
						this.fileUploadPreviewSrc = e.target.result;
					};
					reader.readAsDataURL(this.fileUpload);
				}
			},
			// Clear form when pressing Clear
			clearForm() {
				this.fileUpload = null;
				this.fileUploadPreviewSrc = "";
			},
			// Upload image to server when pressing Upload
			faceFormSubmitted() {
				// Prevent user input
				this.isLoading = true;
				let loadingComponent = this.$buefy.loading.open();

				let formData = new FormData();
				formData.append("employeeJSON", JSON.stringify(this.currentEmployee));
				formData.append("imageFile", this.fileUpload);

				// apiService
				// 	.uploadFace(formData)
				new Promise((res) => setTimeout(res, 2000))
					.then(() => {
						// DEMO
						this.$buefy.snackbar.open({
							duration: 3000,
							message: "This functionality has been disabled for the demo.",
							type: "is-warning",
							position: "is-top-right",
							queue: false
						});
						// this.$buefy.snackbar.open({
						// 	duration: 10000,
						// 	message: "Your image was uploaded successfully and will be processed in a few minutes.",
						// 	type: "is-success",
						// 	position: "is-top",
						// 	queue: false
						// });
						loadingComponent.close();
						this.$parent.close();
					})
					.catch((err) => {
						console.log(err, err.response.data);

						this.$buefy.snackbar.open({
							duration: 5000,
							message: "Error: " + err.response.data.message,
							type: "is-danger",
							position: "is-top-right"
						});
						loadingComponent.close();
						this.$parent.close();
					});
			}
		}
	};
</script>
